module.exports = __webpack_public_path__ + "static/media/placeholder.25127285.svg";